// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : created saga
// MODIFIED DATE : 06-10-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import ENACHReportActionTypes from './MandateReport.types';
import { fetchENACHMandateReport } from './MandateReport.service';
import {
	fetchENACHMandateReportFailure,
	fetchENACHMandateReportSuccess,
	fetchENACHMandateReportResponseChanged,
} from './MandateReport.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START MANDATE REPORT DETAILS  ******************** */
export function* fetchENACHMandateReportDetails({ payload }: any) {
	try {
		const key = 'EnachMandateReportListKey';
		const { companyID, databaseName, fromDate, toDate } = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(fetchENACHMandateReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchENACHMandateReportFailure(responseData.data));
		} else {
			yield put(fetchENACHMandateReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchENACHMandateReportFailure(error));
	}
}

export function* resetFetchEnachMandateReportResponse() {
	yield put(fetchENACHMandateReportResponseChanged());
}

export function* onFetchENACHMandateReport() {
	yield takeLatest(
		ENACHReportActionTypes.FETCH_ENACH_MANDATE_REPORT_START,
		fetchENACHMandateReportDetails,
	);
}

export function* onFetchENACHMandateReportResponseReset() {
	yield takeLatest(
		ENACHReportActionTypes.FETCH_ENACH_MANDATE_REPORT_RESPONSE_RESET,
		resetFetchEnachMandateReportResponse,
	);
}
/** *********************  END MANDATE REPORT DETAILS ******************** */

export function* mandateReportSaga() {
	yield all([call(onFetchENACHMandateReport), call(onFetchENACHMandateReportResponseReset)]);
}
